export const BACKEND_POSTHOG_FEATURE_FLAGS = {
  GOFUNDME_USER_JOURNEYS_AB_TEST: 'gofundme_user_journeys_ab_test'
} as const

export type BackendPostHogFeatureFlag = typeof BACKEND_POSTHOG_FEATURE_FLAGS[keyof typeof BACKEND_POSTHOG_FEATURE_FLAGS]
